<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button (click)="goBack()"></ion-back-button>
    </ion-buttons>
    <ion-title>Sitemap</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button (click)="toggleDisplay()">
          {{ showVersions ? 'Show Only Names' : 'Show Names with Versions' }}
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-list>
    <ion-item *ngFor="let route of sortedRoutes" [routerLink]="route.path">
      {{ route.name }}<span *ngIf="showVersions"> (v{{ route.version }})</span>
    </ion-item>
  </ion-list>
</ion-content>
